import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState, useSyncExternalStore } from 'react';
import { Accordion, Badge, Button, ButtonGroup, Col, Container, FloatingLabel, Form, Image, InputGroup, Row, Tab, Table, Tabs, ToggleButton } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { LoginInfo } from '../App';
import { isAdmin } from '../service/LoginService';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import parse, { domToReact } from 'html-react-parser'
import { rankingBgColor,rankingOpacity } from "./common/RankingUtil";
import { Bar, Line } from 'react-chartjs-2';
import { Chart, registerables } from "chart.js"
import ImageViewPopup from './ImageViewPopup';
import Thumb from './common/Thumb';
import { t } from 'i18next';
import VideoViewPopup from './VideoViewPopup';

const Video = () => {
    function search(keyword,style,nenrei,follow,aiOrModel,user,tag,order,page){
        return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/video/search/",
            {keyword:keyword,style:style,ageLimit:nenrei,follow:follow,aiOrModel:aiOrModel,user:user,tag:tag,postDateFrom:"",postDateTo:"",order:order,page:page}
        ).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getVideo(page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/video/new/all/all//"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function favoriteSumExecute(ymd){
        return new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/favorite/sum/"+ymd).then((r)=>{
            return r.json()
        })
    }
    function getRegistrationByDay(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/registrations").then((r)=>{
            return r.json()
        })
    }
    function getRegistrationTotalByDay(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/registrationsTotal").then((r)=>{
            return r.json()
        })
    }
    function getPostsByDay(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/posts").then((r)=>{
            return r.json()
        })
    }
    async function getRankingImage(period,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/ranking/illustration/general/"+period+"/s_all/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function createRankingRecord(ymd){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/rankingRecord/",{ymd:ymd}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function tagSearch(tag,page){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/tag_safe/",{tag:tag,page:page}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getOdai3Days(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/odai/3days/").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function odaiRegistExecute(odaiRegistDate,registOdai){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/odai/info",{ymd:odaiRegistDate,odai:registOdai}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getReportList(page,searchDiv){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/report/list/"+page+"/"+searchDiv).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function updateReportStatus(reportId,status){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/report",{reportId:reportId,status:status}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getUserCheckList(page,searchDiv){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/checkList/"+page+"/"+searchDiv).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getMessage(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/info").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function getAgeLimitStr(ageLimit,sexualExpression){
        let nenrei = ""
        if(ageLimit === 1 && sexualExpression === 2){
            nenrei = "全年齢"
        } else if(ageLimit === 1 && sexualExpression === 1){
            nenrei = "R-15"
        } else if(ageLimit === 2){
            nenrei = "R-18"
        } else if(ageLimit === 3){
            nenrei = "R-18G"
        }
        return nenrei
    }
    const location = useLocation()
    const navigate = useNavigate()

    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    const [messageList,setMessageList] = useState([])
    const [list,setList] = useState([])
    const [eventPage,setEventPage] = useState(1)
    const [favoriteSumDate,setFavoriteSumDate] = useState()
    const [rankingCreateDate,setRankingCreateDate] = useState()
    const [registrationList,setRegistrationList] = useState([])
    const [registerCount,setRegisterCount] = useState("未取得")
    const [registrationTotalList,setRegistrationTotalList] = useState([])
    const [registerTotalCount,setRegisterTotalCount] = useState("未取得")
    const [postsList,setPostsList] = useState([])
    const [rankingTargetDate,setRankingTargetDate] = useState("")
    const [rankingImageList,setRankingImageList] = useState([])
    const [rankingDetail,setRankingDetail] = useState(false)
    const [rankingBlur,setRankingBlur] = useState(false)
    const [tagImageList,setTagImageList] = useState([])
    const [tagDetail,setTagDetail] = useState(false)
    const [odaiList,setOdaiList] = useState([])
    const [odaiRegistDate,setOdaiRegistDate] = useState("")
    const [registOdai,setRegistOdai] = useState("")
    const [reportList,setReportList] = useState([])
    const [userCheckList,setUserCheckList] = useState([])

	useEffect(() => {
        getVideo(eventPage).then(r => {
            if(r.result){
                setList(r.data)
            }
        })
        // メッセージ取得
        getMessage().then(r=>{
            if(r.result){
                setMessageList(r.data)
            }
        })
		document.querySelector("title").textContent = t("upload.event.title") + " - アワートAI"
	},[eventPage])

    function createGraphData(r,title){
        const graphData = {
            labels: 
                // 軸ラベル
                // 各ラベルを配列にすることで軸ラベルが改行されて表示される
                r.map(d => [d.ymd])
            ,
            datasets: [
                // 表示するデータセット
                {
                    data: r.map(d => d.count),
                    label: title
                },
            ],
        }
        return graphData
    }
    const [showImageViewPopup,setShowImageViewPopup] = useState(false)
    const [groupId,setGroupId] = useState()
    const [radioReportSearchDiv,setReportSearchDiv] = useState("3")
    const [reportSearchPage,setReportSearchPage] = useState(1)
    const [radioUserCheckListSearchDiv,setUserCheckListSearchDiv] = useState("1")
    const [userCheckListSearchPage,setUserCheckListSearchPage] = useState(1)

    const reportSearchDiv = [
        { name: "未対応", value: "1"},
        { name: "対応済", value: "2"},
        { name: "全て", value: "3"},
    ]

    const checkListSearchDiv = [
        { name: "不整合あり", value: "1"},
        { name: "不整合なし", value: "2"},
        { name: "全て", value: "3"},
    ]

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    const tagReplace = (node) => {
        if (node.name === 'span' && node.attribs.tag !== undefined) {
          return (
            <span {...node.attribs} onClick={() => navigate("/tag/"+node.attribs.tag+"/1")} style={{color:"#00AAFF",cursor:"pointer"}}>
              #{ domToReact(node.children) }
            </span>
          )
        }
        if (node.name === 'span' && node.attribs.href !== undefined) {
            return (
              <span {...node.attribs} onClick={() => navigate("/video/"+node.attribs.href)} style={{color:"#00AAFF",cursor:"pointer"}}>
                { domToReact(node.children) }
              </span>
            )
        }
    }
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        {showImageViewPopup ? <VideoViewPopup groupId={groupId} switch={setShowImageViewPopup} /> : ""}
        <Container className='mt-3 mb-3'>
            <Tabs defaultActiveKey="video" className="mt-3 mb-3"
            onSelect={s => {
                if(s === "image"){
                    navigate("/")
                } else if(s === "video"){
                    navigate("/video")
                } else if(s === "text"){
                    navigate("/text")
                } else if(s === "event"){
                    navigate("/event")
                }
            }}
            >
                <Tab eventKey="image" title={t("upload.image.title")}></Tab>
                <Tab eventKey="video" title={t("upload.video.title")}>
                    <Container className='d-none'>
                        <Button variant='outline-secondary'>同人誌即売会</Button>
                        <Button variant='outline-secondary' style={{marginLeft:"10px"}}>技術イベント</Button>
                    </Container>
                    <div>
                        <p style={{borderBottom:"3px solid #55AAFF",fontSize:"24px",fontWeight:"bold"}}>{t("upload.video.title")}</p>
                        <Link to={"/upload/video"}>{t("upload.video.title")}を登録する</Link>
                        <p>
                            以下のような内容の投稿ができます。<br />
                            AIを活用して生成された動画、AIに関する解説動画等。<br />
                            GIFアニメーションは<Link to={"/upload/image"}>画像作品</Link>として投稿してください。
                        </p>
                        <hr />
                        {list.map((d,i) => {
                        return <><div className='d-flex' style={{}}>
                            <div style={{width:"300px"}}>
                                <Thumb data={{group_id:d.group_id,status:d.status}} i={i} key={i} list={list} type="video" />
                            </div>
                            <div>
                                <h5 style={{color:"#555555",fontWeight:"normal"}}><Link to={"/video/"+d.group_id}>{d.title}</Link></h5>
                                <p  style={{whiteSpace:"pre"}}>{parse(d.description.replace(/[#＃]{1}([Ａ-Ｚａ-ｚA-Za-z一-鿆0-9０-９ぁ-ヶｦ-ﾟー._-・]?[^　 #＃\r\n]+)/g,'<span tag="$1">$1</span>').replace(/\r\n|\r|\n/g,"<br />").replace(/https:\/\/ourt-ai\.work\/image\/([0-9a-z-]{36})/g,"<span href='$1/'>画像リンク</span><br />"),{replace:tagReplace})}</p>
                            </div>
                        </div>
                        <hr />
                        </>
                        })}
                    </div>
                    <Container className='d-flex justify-content-between mt-3' style={{width:"200px"}}>
                    {eventPage > 1 ? (
                            <Button variant='outline-primary' onClick={() => {
                                let page = eventPage - 1
                                setEventPage(page)
                            } }>{t("common.prev")}</Button>
                        ) : <Button disabled>{t("common.prev")}</Button>}
                    {list.length > 50 ? (
                            <Button variant='outline-primary' onClick={() => {
                                let page = eventPage + 1
                                setEventPage(page)
                            } }>{t("common.next")}</Button>
                        ) : <Button disabled>{t("common.next")}</Button>}
                    </Container>
                </Tab>
                <Tab eventKey="text" title={t("upload.text.title")}></Tab>
                <Tab eventKey="event" title={t("upload.event.title")}></Tab>
                <Tab eventKey={"info"} title={t("common.information")}>
                    <ul>
                        {messageList.map((data,i) => {
                            let category = ["機能追加","機能改善","イベント","提携","その他"]
                            if(data.url.length > 0){
                                return <li className='m-1' key={i}><span style={{fontSize:"14px",color:"#777777"}}>{data.release_datetime}</span><br /><Badge>{category[data.reason-1]}</Badge> <Link to={data.url}>{data.text}</Link></li>
                            } else {
                                return <li className='m-1' key={i}><span style={{fontSize:"14px",color:"#777777"}}>{data.release_datetime}</span><br /><Badge>{category[data.reason-1]}</Badge> {data.text}</li>
                            }
                        })}
                    </ul>
                </Tab>
            </Tabs>
        </Container>
        <Container>
            
        </Container>
    <Footer />
</div>
    )
}

export default Video;
